import * as Sentry from '@sentry/react';

// The DSN is a *public* identifier — Sentry docs say it's fine to
// commit to source. Rotating it means creating a new project, so
// treat it like a URL, not a secret. Overridable via `SENTRY_DSN`
// at build time (webpack DefinePlugin) so a fork can point at a
// different project without editing this file.
const DSN =
  (typeof process !== 'undefined' && process.env && process.env.SENTRY_DSN) ||
  'https://24312b4f42765b063594b2b6598d2233@o4511827874611200.ingest.us.sentry.io/4511827883524096';

// The legacy Shakapacker frontend runs React 16. `@sentry/react` v7
// (installed at the repo root) is the last major that supports React
// 16.13, so keep the root pinned to `^7`. The SPA in `frontend/` uses
// v10 against React 18 — they are separately versioned.
//
// Only initializes for production builds (`NODE_ENV=production`) so
// dev sessions don't ship events. Set `FORCE_SENTRY=1` at build time
// to override that guard for a smoke test.
export function initSentry() {
  if (!DSN) return;
  const nodeEnv =
    typeof process !== 'undefined' && process.env
      ? process.env.NODE_ENV
      : undefined;
  const force =
    typeof process !== 'undefined' && process.env
      ? process.env.FORCE_SENTRY === '1'
      : false;
  if (nodeEnv !== 'production' && !force) return;
  Sentry.init({
    dsn: DSN,
    environment: nodeEnv || 'production',
    tracesSampleRate: 0,
    sendDefaultPii: false,
    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications',
    ],
  });
}

export { Sentry };
